import {
  PaymentsIdentityFileModel,
  PaymentIdentityUboModel,
} from '@marketplace-web/pay-identity/payments-identity-data'
import { NationalityCountryModel } from '@marketplace-web/nationality-select/nationality-select-data'
import { AddressModel } from '@marketplace-web/address/address-data'
import { PepType as PepTypeVariant } from '@marketplace-web/pay-identity/politically-exposed-person-data'

export enum Field {
  FirstName = 'firstName',
  LastName = 'lastName',
  Birthdate = 'birthdate',
  Nationality = 'nationality',
  SsnSerial = 'ssnSerial',
  PersonalIdNumber = 'personalIdNumber',
  IdentityDocument = 'identityDocument',
  SupportingDocuments = 'supportingDocuments',
  PepType = 'pepType',
  PepFullName = 'pepFullName',
  PepPosition = 'pepPosition',
  PepOrganisation = 'pepOrganisation',
  PepPositionDate = 'pepPositionDate',
}

export type FormModel = {
  [Field.FirstName]: string
  [Field.LastName]: string
  [Field.Birthdate]: string
  [Field.Nationality]?: NationalityCountryModel
  [Field.SsnSerial]?: string
  [Field.PersonalIdNumber]?: string
  [Field.IdentityDocument]: PaymentsIdentityFileModel
  [Field.SupportingDocuments]: Array<PaymentsIdentityFileModel>
  ubos: Array<PaymentIdentityUboModel>
  [Field.PepType]?: PepTypeVariant
  [Field.PepFullName]?: string
  [Field.PepPosition]?: string
  [Field.PepOrganisation]?: string
  [Field.PepPositionDate]?: string
}

export type FormData = {
  firstName: string | null
  lastName: string | null
  birthdate: string | null
  nationality?: NationalityCountryModel | null
  ssnSerial?: string | null
  personalIdNumber?: string | null
  address: AddressModel | null
  isLegalRepresentativeUbo: boolean
  ubos: Array<PaymentIdentityUboModel> | null
  documents: Array<PaymentsIdentityFileModel> | null
  pepType?: PepTypeVariant
  pepFullName?: string | undefined
  pepPosition?: string | undefined
  pepOrganisation?: string | undefined
  pepPositionDate?: string | undefined
}

export type generalErrors = {
  byName: { [fieldName: string]: string }
  names: Array<string>
}

export enum AddressScreenTrackingType {
  Escrow = 'escrow',
  SettingsBillingAddress = 'settings_billing_address',
  SettingsShippingAddress = 'settings_shipping_address',
  SettingsBalanceActivation = 'settings_balance_activation',
}
